import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import RouteContainer from 'src/components/App/RouteContainer'

const TrainerCreateForm = React.lazy(() => loadComponent('traiwiss', 'TrainerCreateForm'))

export function TrainerCreateRoute() {
    const navigate = useNavigate()
    const { academy } = useFlightDeck()

    const onCreate = useCallback(() => {
        navigate(`/trainers`)
    }, [navigate])

    const onClose = useCallback(() => {
        navigate(`/trainers`)
    }, [navigate])

    return (
        <RouteContainer>
            <TrainerCreateForm academyId={academy?._id} onCreated={onCreate} onClosed={onClose} />
        </RouteContainer>
    )
}
